import { render, staticRenderFns } from "./PensionEntitiesView.vue?vue&type=template&id=c1a91456"
import script from "./PensionEntitiesView.vue?vue&type=script&lang=js"
export * from "./PensionEntitiesView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports